<template>
  <v-app id="vuetify-app">
    <v-container fluid>
      <v-layout align-center justify-center row fill-height>
        <v-flex xs12 md4>
          <v-card>
            <v-card-title>
              <h3>
                {{ `app.mobile_app.download.download` | trans }}
              </h3>
            </v-card-title>
            <v-card-text>
              <p>
                {{ `app.mobile_app.download.download_description` | trans }}
              </p>
              <div>
                <mobile-app-download :app-store-link="appStoreLink" :google-play-link="googlePlayLink"/>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <a :href="routes.logout">{{ `app.logout` | trans }}</a>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-app>
</template>
<script>

export default {
  props: {
    routes: Object,
    appStoreLink: String,
    googlePlayLink: String,
  }
}
</script>
